export type BoardGroupByOptions = 'user' | 'list' | 'none'

export enum GroupByOptions {
  none = 'none',
  project = 'project',
  projectType = 'projectType',
  typeOfWork = 'typeOfWork',
  upcomingDaily = 'upcomingDaily',
  upcomingWeekly = 'upcomingWeekly',
  upcomingMonthly = 'upcomingMonthly',
  projectStatus = 'projectStatus',
  projectStatusType = 'projectStatusType',
  priority = 'priority',
  responsibleUser = 'responsibleUser',
  taskStatusType = 'taskStatusType',
  createdBy = 'createdBy',
  dueMonth = 'dueMonth',
  dueWeek = 'dueWeek',
  client = 'client',
  workflow = 'workflow',
  user = 'user',
  list = 'list',
  taskLists = 'taskLists'
}

export enum ProjectSortByOptions {
  members = 'members',
  client = 'client',
  projectType = 'projectType',
  responsibleUser = 'responsibleUser',
  status = 'status',
  workflow = 'workflow',
  dueDate = 'dueDate',
  startDate = 'startDate',
  createdOn = 'createdOn',
  name = 'name',
  key = 'key',
  budget = 'budget',
  progress = 'progress',
  totalTasks = 'totalTasks',
  taskProgress = 'taskProgress',
  timeProgress = 'timeProgress',
  default = 'default'
}

export enum TimeTrackingReportSortByOptions {
  dateUpdated = 'dateUpdated',
  reportName = 'reportName'
}

export enum DocsGroupByOptions {
  none = 'none',
  task = 'task',
  fileType = 'fileType',
  user = 'user'
}

export enum DocsSortByOptions {
  date = 'date',
  name = 'name',
  task = 'task'
}

export enum TimeTrackingTimeFrameOptions {
  Today = 'today',
  Yesterday = 'yesterday',
  ThisMonth = 'thisMonth',
  LastMonth = 'lastMonth',
  AllTime = 'allTime'
}

export enum TimeTrackingGroupingOptions {
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Quarter = 'quarter',
  Year = 'year',
  User = 'user',
  TypeOfWork = 'typeOfWork',
  Billability = 'billability',
  Project = 'project'
}

export const TimeTrackingValidGroupingOptions = [
  TimeTrackingGroupingOptions.Project,
  TimeTrackingGroupingOptions.User,
  TimeTrackingGroupingOptions.TypeOfWork,
  TimeTrackingGroupingOptions.Billability
]

export type ValidBarChartGroupingOptions =
  | TimeTrackingGroupingOptions.Project
  | TimeTrackingGroupingOptions.User
  | TimeTrackingGroupingOptions.TypeOfWork
  | TimeTrackingGroupingOptions.Billability
